export default __webpack_public_path__ + "static/51277-88ffc0c8bc045b78b3002f95bfcdcad0.jpg";